export default __webpack_public_path__ + "static/hotham-australia-4d27fe839e3f972207e63dbe80788017.jpg";